<template>
    <div class="d-flex flex-grow-1">
        <top-menu @toggleDrawer="toggleMini" :is-dashboard="true" />
        <user-drawer-menu :mini="mini" />
        <v-main :style="{ background: '#F3F1F1' }" v-if="loading">
            <v-container>
                <slot> <!--CONTENT--> </slot>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import UserDrawerMenu from "../components/dashboard/UserDrawerMenu";
import TopMenu from "../components/TopMenu";
import Settings from "@/models/Settings";
import {mapActions} from "vuex";
import {readNavMini, writeNavMini} from "@/utils/navState";

// Merely touching window.localStorage can throw when the browser blocks storage.
const getNavStorage = () => {
    try {
        return window.localStorage;
    } catch (error) {
        return null;
    }
};

export default {
    name: "user-dashboard-layout",
    components: { TopMenu, UserDrawerMenu },
    data: function() {
        return {
            mini: readNavMini(getNavStorage()),
            loading: false,
            shop_settings: [],
        };
    },
    methods: {
        ...mapActions(['fillSettings']),
        toggleMini() {
            this.mini = !this.mini
            writeNavMini(getNavStorage(), this.mini)
        },
    },
    async mounted() {
        this.loading = false
        this.shop_settings = await Settings.get()
        this.fillSettings(this.shop_settings)
        this.loading = true
    }
};
</script>

<style scoped></style>
